
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pet-insurance",
      function () {
        return require("private-next-pages/pet-insurance.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pet-insurance"])
      });
    }
  